import React from "react";
import { useLocation, Switch, Route, Redirect } from "react-router-dom";

// components
import Navbar from "components/Navbars/AuthNavbar.js";
import FooterSmall from "components/Footers/FooterSmall.js";

// views
import Login from "views/auth/Login.js";
import Register from "views/auth/Register.js";
import Welcome from "views/auth/Welcome";

//video
import vid from "../assets/img/zippyops.mp4";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  return (
    <>
      <Navbar transparent />
      <main>
        <section
          className="relative w-full h-full py-40 min-h-screen"
          ref={mainContent}
        >
          <video
            autoPlay
            loop
            muted
            style={{
              position: "fixed",
              width: "100%",
              left: "50%",
              top: "50%",
              height: "100%",
              objectFit: "cover",
              transform: "Translate(-50%, -50%)",
              zIndex: "-1",
            }}
          >
            <source src={vid} type="video/mp4" />
          </video>

          <Switch>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/auth/register" exact component={Register} />
            <Route path="/auth/welcome" exact component={Welcome} />
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
          <FooterSmall absolute />
        </section>
      </main>
    </>
  );
};

export default Auth;
